import React, { useState } from "react";
import mintBlob from "../../assets/images/Image-bg.png"; // Adjust the path to your mint blob image
import profileImage from "../../assets/images/vector-office-worker-with-laptop.png"; // Adjust the path to your profile image
import GetStartedDialog from "./GetStartedDialog";
export default function Homebanner() {
  const [open, setOpen] = useState(false);
  const handleDownloadCV = () => {
    // 1. Open in new tab
    window.open("/Divyasri_Kandavalli_Resume.pdf", "_blank");

    // 2. Trigger download
    const link = document.createElement("a");
    link.href = "/Divyasri_Kandavalli_Resume.pdf";
    link.download = "Divyasri_Kandavalli_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <section className="relative max-w-7xl mx-auto text-[#F8F8F8] px-8 2xl:px-0 flex flex-col lg:flex-row items-center justify-center gap-10 h-full pt-10 md:pt-10 3xl:pt-32">
      {/* Left Column - Text and Buttons */}
      <div className="xl:w-1/2">
        <ul className="list-none mb-4">
          <li className="text-[#F8F8F8] flex items-center before:content-[''] before:w-3 before:h-3 before:mr-2 before:bg-gradient-to-r before:from-[#6cfcb5] before:to-[#F0FF6C] before:rounded-full text-[16px] font-medium leading-[1.4em]" data-aos="fade-up" data-aos-delay="200">
            Your Dream, My Code Reality
          </li>
        </ul>
        <h1 className="text-[32px] md:text-[42px] 2xl:text-[52px]  leading-[1.2em] font-semibold mb-4" data-aos="fade-up" data-aos-delay="300">
          <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
            I'm Divya Sri,
          </span>{" "}
          <br />
          MERN Developer
          <br /> 3+ Years Experience
        </h1>
        <p className="text-[#F8F8F8] mb-6 font-medium text-left text-[16px]" data-aos="fade-up" data-aos-delay="350">
          Hi, I'm Divya Sri, a MERN Stack Developer with 3+ years of
          experience building responsive and scalable web applications. I enjoy
          creating efficient, user-friendly interfaces and developing reliable
          backend systems using modern JavaScript technologies.
        </p>
        <div className="xs:block sm:flex sm:space-x-4 space-y-4 sm:space-y-0 xl:mt-10" data-aos="fade-up" data-aos-delay="400">
          <button
            onClick={() => setOpen(true)}
            className="px-6 py-3 bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] text-[#163031] rounded-full hover:bg-gradient-to-l transition-all duration-300 font-semibold"
          >
            Get Started
          </button>
          <button
            className="
  relative px-6 py-3 rounded-full font-semibold flex items-center
  bg-[#1f3d3b] text-white
  overflow-hidden transition-all duration-300
  hover:text-black hover:scale-105 active:scale-95

  before:absolute before:top-0 before:-left-full
  before:w-full before:h-full
  before:bg-white
  before:transition-all before:duration-500
  before:rounded-full before:z-0

  hover:before:left-0
"
          >
            <span className="relative z-10 mr-2"  onClick={handleDownloadCV}>Download CV</span>
          </button>
        </div>
      </div>

      {/* Right Column - Image and Details */}
      <div className="xl:w-1/2 relative flex justify-end mx-auto">
        <div className="relative">
          <img
            src={mintBlob}
            alt="Mint Blob Background"
            className="absolute top-0 left-0 w-auto h-auto z-0"
          />
          <img
            src={profileImage}
            alt="Profile"
            className="relative z-10  w-auto h-auto"
          />
        </div>
      </div>
      <GetStartedDialog open={open} onClose={() => setOpen(false)} />
    </section>
  );
}
